import { Space } from "@mantine/core";
import { Intro } from "../Components/Intro";
import { Vorträge } from "../Components/Vorträge";

export const SelectVortrag = () => {
  return (
    <>
      <Intro />
      <Space h="xl" />
      <Vorträge />
    </>
  );
};
